<!-- <ion-content> -->

<div class="iframe">
  <iframe [src]="url" width="100%" height="100%" frameBorder="0" allowfullscreen="allowfullscreen"></iframe>
</div>
<!-- <ion-content> -->
